import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalVar } from '../globals/global-var';

//全局發送請求攔截加入token，需要再app.module啟用

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorTokenService {

  constructor(private globalVar: GlobalVar) { }

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.globalVar.progressBar = true;
    // token 可以來自任何地方
    const newRequest = req.clone({ setHeaders: { Authorization: 'bearer ' + sessionStorage.getItem('authSystem_token') } });
    return next.handle(newRequest);
  }

}
